import React from 'react';
import PropTypes from 'prop-types';
import { params as constants } from './../helpers';
import {
  Col,
  Panel,
  Row,
} from 'react-bootstrap';
import moment from 'moment';
import ActionButtonListComponent from '../Components/ActionButtonListComponent';

const DispatcherInfoComponent = ({
  dispatcher,
  dispatcherDropdownActions,
  dispatcherJobInfo,
  dispatcherParams,
  onActionButtonClick
}) => {
  const triggeredBy = dispatcherParams && dispatcherParams[constants.JENKINS_TRIGGER_BY] || '';
  const paramKeys = [
    ...Object.keys(dispatcherParams || {}),
    'CREATED_AT'
  ];

  return (
    <Panel collapsible="true">
      <Panel.Heading>
        <Panel.Title>
          <div className="flex">
            <div className="flex-grow">
              <Panel.Toggle>
                {dispatcherJobInfo.jobName && dispatcherJobInfo.jobNumber ?
                  `${dispatcherJobInfo.jobName}_${dispatcherJobInfo.jobNumber} - ${triggeredBy}` :
                  'No Dispatcher Selected'}
              </Panel.Toggle>
            </div>
            <ActionButtonListComponent
              actions={dispatcherDropdownActions}
              itemId={Number(dispatcherJobInfo.jobId)}
              onButtonClick={onActionButtonClick}
            />
          </div>
        </Panel.Title>
      </Panel.Heading>
      <Panel.Collapse>
        <Panel.Body>
          <div>
            {
              paramKeys.sort().map((key, i) => {

                // Modified key to check for "JENKINS_ENV:" in param
                let modifiedKey;
                if (key.indexOf('JENKINS_ENV:') === 0) {
                  modifiedKey = key.split(':')[1];
                }
                if (constants.DISPATCHER_INFO_PARAM_NAMES.indexOf(key) >= 0) {
                  if (key === 'CREATED_AT') {
                    const createdMoment = dispatcher && dispatcher.created_at ?
                      moment(dispatcher.created_at, 'YYYY-MM-DDTHH:mm:ssz') :
                      null;
                    return createdMoment ? (<div key={i}>
                      <Row>
                        <Col md={6}>{key}</Col>
                        <Col md={6}>
                          {createdMoment.toString()}
                        </Col>
                      </Row>
                    </div>) : null;
                  }
                  return dispatcherParams && dispatcherParams[key] ? (
                    <div key={i}>
                      <Row>
                        <Col md={6}>{modifiedKey ? modifiedKey : key}</Col>
                        <Col md={6}>
                          {dispatcherParams[key]}
                        </Col>
                      </Row>
                    </div>) : null;
                }
              })
            }
          </div>
        </Panel.Body>
      </Panel.Collapse>
    </Panel>
  );
};

DispatcherInfoComponent.propTypes = {
  dispatcher: PropTypes.object.isRequired,
  dispatcherDropdownActions: PropTypes.arrayOf(
    PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        onSelect: PropTypes.func.isRequired,
        isDisabled: PropTypes.bool
      })
    )
  ),
  dispatcherJobInfo: PropTypes.shape({
    jobId: PropTypes.oneOfType[
      PropTypes.string, PropTypes.number],
    jobName:  PropTypes.string,
    jobNumber: PropTypes.oneOfType[
      PropTypes.string, PropTypes.number]
  }).isRequired,
  dispatcherParams: PropTypes.object.isRequired,
  onActionButtonClick: PropTypes.func.isRequired
};

export default DispatcherInfoComponent;


// WEBPACK FOOTER //
// src/Components/DispatcherInfoComponent.jsx